import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIdentity } from "../lib/identity";
import { unifiedLogout } from "../lib/unified-auth";

export default function LogoutPage() {
  const navigate = useNavigate();
  const { clearIdentity } = useIdentity();

  useEffect(() => {
    (async () => {
      await unifiedLogout();
      clearIdentity();
      navigate("/login", { replace: true });
    })();
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg-subtle)" }}>
      <p className="text-muted" style={{ fontSize: "0.9375rem" }}>Signing out...</p>
    </div>
  );
}
